import i18n from 'i18next';

import { Text } from '@components';
import ConditionsDisplay from '@components/DraggableTable/DraggableTableCell/ConditionTableCell';
import { CellType } from '@enums';
import type { Column } from '@types';
import { convertOptionList, getColumnSizes } from '@utils';

export const CdnRouteListTable = (originOption): Column[] => [
  { label: i18n.t('configuration:tables.id'), multiLines: true, value: 'id', ...getColumnSizes(50) },
  { label: i18n.t('configuration:tables.rulesName'), value: 'name', multiLines: true, ...getColumnSizes(110) },
  {
    label: i18n.t('configuration:tables.rules'),
    value: 'origin_id',
    format: (value: string, fullData) => {
      const { getLabelByValue } = convertOptionList({
        originalOptions: originOption,
        defaultOptions: '',
        output: { value: 'id', label: 'name' },
      });
      return (
        <div className="space-y-4 mb-1.5">
          <div className="">
            <Text $level={4} $customizeColor className="text-theme-primary-main mb-2.5 font-medium">
              {i18n.t('form:waf.content.originServer')}
            </Text>
            <div className="flex items-start">
              <div className="w-[12px] h-[1px] bg-theme-primary-main/20  mr-[8px] mt-2"></div>
              <Text $level={5} $customizeColor>
                {getLabelByValue(value)}
              </Text>
            </div>
          </div>
          <div>
            <Text $level={4} $customizeColor className="text-theme-primary-main mb-2.5 font-medium">
              {i18n.t('configuration:tables.conditions')}
            </Text>
            <ConditionsDisplay data={fullData?.conditions} />
          </div>
        </div>
      );
    },
    cellType: CellType.Custom,
    multiLines: true,
    ...getColumnSizes(200),
  },
  {
    label: i18n.t('configuration:tables.action'),
    value: 'actions',
    cellType: CellType.Action,
    multiLines: true,
    ...getColumnSizes(90),
  },
];

export const getCdnRoutePriorityColumns = (): Column[] => [
  { label: i18n.t('configuration:tables.id'), value: 'original_id', multiLines: true, ...getColumnSizes(40) },
  { label: i18n.t('configuration:tables.rulesName'), value: 'name', multiLines: true, ...getColumnSizes(100) },
];
